import { Role } from '@/_helpers/role'

export default [
  {
    header: 'Finances',
    icon: 'BriefcaseIcon',
    children: [
      {
        icon: 'ShuffleIcon',
        title: 'CashFlow',
        route: 'CashFlow',
      },
      {
        icon: 'DollarSignIcon',
        title: 'Salaries payout',
        route: 'Salaries',
      },
    ],
    role: [Role.Admin],
  },
  {
    header: 'Work Pool',
    icon: 'UsersIcon',
    route: 'Clients',
    children: [
      {
        icon: 'CodepenIcon',
        title: 'Projects',
        route: 'Work-Pool-Projects',
      },
      {
        icon: 'ClipboardIcon',
        title: 'Contracts',
        route: 'Work-Pool-Contracts',
      },
      {
        icon: 'ClipboardIcon',
        title: 'Unconfirmed Contracts',
        route: 'Work-Pool-Unconfirmed-Contracts',
      },
    ],
    role: [Role.Admin],
  },
  {
    title: 'Talents',
    icon: 'UsersIcon',
    route: 'Comrades',
    role: [Role.Admin],
  },
  {
    header: 'Reporting',
    icon: 'ClipboardIcon',
    role: [Role.Admin],
    children: [
      {
        title: 'Projects',
        route: 'Reports-Projects',
        icon: 'CodepenIcon',
      },
      {
        title: 'Talents',
        route: 'Reports-Comrades',
        icon: 'UsersIcon',
      },
      {
        title: 'Breakdown',
        route: 'Reports-Workloads',
        icon: 'PieChartIcon',
      },
    ],
  },
  {
    title: 'Projects',
    route: 'Reports-Projects',
    icon: 'CodepenIcon',
    role: [Role.Manager]
  },
  /*{
    header: 'Interviews',
    icon: 'PhoneIcon',
    children: [
      {
        title: 'Interviews',
        route: 'Interviews',
        icon: 'PhoneIcon',
      },
      {
        title: 'Settings',
        route: 'InterviewsSettings',
        icon: 'SettingsIcon',
      },
    ],
    role: [Role.Admin],
  },*/
  {
    header: 'Settings',
    icon: 'SettingsIcon',
    children: [
      {
        title: 'All',
        route: 'Settings',
        icon: 'SettingsIcon',
      },
      {
        title: 'Tags',
        route: 'Tags',
        icon: 'TagIcon',
      },
    ],
    role: [Role.Admin],
  },
  {
    title: 'Users',
    icon: 'UserIcon',
    route: 'Users',
    role: [Role.Admin],
  },
]
